import { components } from '@/utils'

const baseClass = 'timeline'

function renderBackground(h) {
  return h(
    'div',
    {
      class: `${baseClass}__dot-background`
    },
    [
      h(
        'div',
        {
          class: `${baseClass}__dot-background-mount`
        }
      ),
      h(
        'div',
        {
          class: {
            [`${baseClass}__dot-background-color`]: true,
            [`${baseClass}__dot-background-color--${this.color}`]: true
          }
        }
      )
    ]
  )
}

function renderIcon(h) {
  return h(
    components.icon,
    {
      class: `${baseClass}__dot-icon`,
      props: {
        value: this.icon,
        color: this.color,
        size: 14
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${baseClass}__dot`,
      directives: this.$_directives
    },
    [
      renderBackground.call(this, h),
      renderIcon.call(this, h)
    ]
  )
}
